const zoneMaxX = 1.35
const zoneMaxY = 1.35

export const zonesReversed = {
    zone_12: [
        { x: -zoneMaxX, y: zoneMaxY },
        { x: -zoneMaxX, y: 0.0 },
        { x: -1, y: 0.0 },
        { x: -1, y: 1 },
        { x: 0, y: 1 },
        { x: 0, y: zoneMaxY },
        { x: -zoneMaxX, y: zoneMaxY },
    ],
    zone_11: [
        { x: zoneMaxX, y: zoneMaxY },
        { x: zoneMaxX, y: 0 },
        { x: 1, y: 0 },
        { x: 1, y: 1 },
        { x: 0, y: 1 },
        { x: 0, y: zoneMaxY },
        { x: zoneMaxX, y: zoneMaxY },
    ],
    zone_14: [
        { x: -zoneMaxX, y: -zoneMaxY },
        { x: -zoneMaxX, y: 0.0 },
        { x: -1, y: 0.0 },
        { x: -1, y: -1 },
        { x: 0, y: -1 },
        { x: 0, y: -zoneMaxY },
        { x: -zoneMaxX, y: -zoneMaxY },
    ],
    zone_13: [
        { x: zoneMaxX, y: -zoneMaxY },
        { x: zoneMaxX, y: 0 },
        { x: 1, y: 0 },
        { x: 1, y: -1 },
        { x: 0, y: -1 },
        { x: 0, y: -zoneMaxY },
        { x: zoneMaxX, y: -zoneMaxY },
    ],
    zone_3: [
        { x: -1.0, y: 1.0 },
        { x: -1.0, y: 0.3332 },
        { x: -0.3331, y: 0.3332 },
        { x: -0.3331, y: 1.0 },
        { x: -1.0, y: 1.0 },
    ],
    zone_2: [
        { x: -0.333, y: 1.0 },
        { x: -0.333, y: 0.3332 },
        { x: 0.333, y: 0.3332 },
        { x: 0.333, y: 1.0 },
        { x: -0.333, y: 1.0 },
    ],
    zone_1: [
        { x: 0.3331, y: 1.0 },
        { x: 0.3331, y: 0.3332 },
        { x: 1.0, y: 0.3332 },
        { x: 1.0, y: 1.0 },
        { x: 0.3331, y: 1.0 },
    ],
    zone_6: [
        { x: -1.0, y: 0.333 },
        { x: -1.0, y: -0.333 },
        { x: -0.3331, y: -0.333 },
        { x: -0.3331, y: 0.333 },
        { x: -1.0, y: 0.333 },
    ],
    zone_5: [
        { x: -0.333, y: 0.333 },
        { x: -0.333, y: -0.333 },
        { x: 0.333, y: -0.333 },
        { x: 0.333, y: 0.333 },
        { x: -0.333, y: 0.333 },
    ],
    zone_4: [
        { x: 0.3331, y: 0.333 },
        { x: 0.3331, y: -0.333 },
        { x: 1.0, y: -0.333 },
        { x: 1.0, y: 0.333 },
        { x: 0.3331, y: 0.333 },
    ],
    zone_9: [
        { x: -1.0, y: -0.3332 },
        { x: -1.0, y: -1.0 },
        { x: -0.3331, y: -1.0 },
        { x: -0.3331, y: -0.3332 },
        { x: -1.0, y: -0.3332 },
    ],
    zone_8: [
        { x: -0.333, y: -0.3332 },
        { x: -0.333, y: -1.0 },
        { x: 0.333, y: -1.0 },
        { x: 0.333, y: -0.3332 },
        { x: -0.333, y: -0.3332 },
    ],
    zone_7: [
        { x: 0.3331, y: -0.3332 },
        { x: 0.3331, y: -1.0 },
        { x: 1.0, y: -1.0 },
        { x: 1.0, y: -0.3332 },
        { x: 0.3331, y: -0.3332 },
    ],
}

export default {
    zone_11: [
        { x: -zoneMaxX, y: zoneMaxY },
        { x: -zoneMaxX, y: 0.0 },
        { x: -1, y: 0.0 },
        { x: -1, y: 1 },
        { x: 0, y: 1 },
        { x: 0, y: zoneMaxY },
        { x: -zoneMaxX, y: zoneMaxY },
    ],
    zone_12: [
        { x: zoneMaxX, y: zoneMaxY },
        { x: zoneMaxX, y: 0 },
        { x: 1, y: 0 },
        { x: 1, y: 1 },
        { x: 0, y: 1 },
        { x: 0, y: zoneMaxY },
        { x: zoneMaxX, y: zoneMaxY },
    ],
    zone_13: [
        { x: -zoneMaxX, y: -zoneMaxY },
        { x: -zoneMaxX, y: 0.0 },
        { x: -1, y: 0.0 },
        { x: -1, y: -1 },
        { x: 0, y: -1 },
        { x: 0, y: -zoneMaxY },
        { x: -zoneMaxX, y: -zoneMaxY },
    ],
    zone_14: [
        { x: zoneMaxX, y: -zoneMaxY },
        { x: zoneMaxX, y: 0 },
        { x: 1, y: 0 },
        { x: 1, y: -1 },
        { x: 0, y: -1 },
        { x: 0, y: -zoneMaxY },
        { x: zoneMaxX, y: -zoneMaxY },
    ],
    zone_1: [
        { x: -1.0, y: 1.0 },
        { x: -1.0, y: 0.3332 },
        { x: -0.3331, y: 0.3332 },
        { x: -0.3331, y: 1.0 },
        { x: -1.0, y: 1.0 },
    ],
    zone_2: [
        { x: -0.333, y: 1.0 },
        { x: -0.333, y: 0.3332 },
        { x: 0.333, y: 0.3332 },
        { x: 0.333, y: 1.0 },
        { x: -0.333, y: 1.0 },
    ],
    zone_3: [
        { x: 0.3331, y: 1.0 },
        { x: 0.3331, y: 0.3332 },
        { x: 1.0, y: 0.3332 },
        { x: 1.0, y: 1.0 },
        { x: 0.3331, y: 1.0 },
    ],
    zone_4: [
        { x: -1.0, y: 0.333 },
        { x: -1.0, y: -0.333 },
        { x: -0.3331, y: -0.333 },
        { x: -0.3331, y: 0.333 },
        { x: -1.0, y: 0.333 },
    ],
    zone_5: [
        { x: -0.333, y: 0.333 },
        { x: -0.333, y: -0.333 },
        { x: 0.333, y: -0.333 },
        { x: 0.333, y: 0.333 },
        { x: -0.333, y: 0.333 },
    ],
    zone_6: [
        { x: 0.3331, y: 0.333 },
        { x: 0.3331, y: -0.333 },
        { x: 1.0, y: -0.333 },
        { x: 1.0, y: 0.333 },
        { x: 0.3331, y: 0.333 },
    ],
    zone_7: [
        { x: -1.0, y: -0.3332 },
        { x: -1.0, y: -1.0 },
        { x: -0.3331, y: -1.0 },
        { x: -0.3331, y: -0.3332 },
        { x: -1.0, y: -0.3332 },
    ],
    zone_8: [
        { x: -0.333, y: -0.3332 },
        { x: -0.333, y: -1.0 },
        { x: 0.333, y: -1.0 },
        { x: 0.333, y: -0.3332 },
        { x: -0.333, y: -0.3332 },
    ],
    zone_9: [
        { x: 0.3331, y: -0.3332 },
        { x: 0.3331, y: -1.0 },
        { x: 1.0, y: -1.0 },
        { x: 1.0, y: -0.3332 },
        { x: 0.3331, y: -0.3332 },
    ],
}
